module.exports = __webpack_public_path__ + "img/ZEITStiftungBucerius_Logo_RGB.2b9baf43.jpg";